export enum OperatingSystem {
  Android = 'android',
  IOS = 'ios',
  Linux = 'linux',
  MacOS = 'macos',
  Windows = 'windows',
}
